<template>
  <div class="w-full relative h-full">
    <div class="map-responsive h-full">
      <div id="map" />
    </div>
    <div
      class="legend"
      style="
        position: absolute;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 3px;
        box-shadow: 0 0 3px #222;
        padding: 5px;
      "
    >
      <div v-for="(series, i) in legend" :key="i" style="margin-bottom: 5px">
        <div>
          <span>
            <img :src="series.src" height="25" />
          </span>
          <span>{{ series.label }}</span>
        </div>
      </div>
    </div>
    <PageLoader v-if="!tenant">
      <template #body>
        <div>
          <i class="fas fa-map-marker-alt"></i>
          Loading Map...
        </div>
      </template>
    </PageLoader>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";

import PageLoader from "@/components/PageLoader.vue";
import directionsDecoder from "@/directionsDecoder.js";
import technicianDefaultMarker from "@/images/technician-marker.svg";

export default {
  components: {
    PageLoader
  },
  mixins: [directionsDecoder],
  data: function () {
    return {
      channel: undefined,
      appointments: [],
      technicians: [],
      map: undefined,
      pins: {},
      allTechs: [],
      legend: []
    };
  },
  computed: {
    ...mapState(["tenant"])
  },
  watch: {
    tenant(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.init();
      }
    }
  },
  mounted() {
    this.fetchTenant();
  },
  methods: {
    ...mapActions(["fetchTenant"]),
    init() {
      if (!this.map) {
        // Default map center in DFW
        let center = {
          lat: 32.934107,
          lng: -97.076533
        };
        if (this.tenant.map_center) {
          center = {
            lat: this.tenant.map_center.latitude,
            lng: this.tenant.map_center.longitude
          };
        }
        const element = document.getElementById("map");
        this.map = new window.google.maps.Map(element, {
          center,
          zoom: 12
        });

        const overlay = new window.google.maps.OverlayView();
        overlay.draw = function () {
          this.getPanes().markerLayer.id = "markerLayer";
        };
        overlay.setMap(this.map);

        this.generatePins();

        this.addTechniciansLastLocation();
        // this.listentTechnicians();
        this.getAllAppointments();
        // this.listenTechnicianSelection();
      }
    },
    getTechPin(id) {
      const pin = Object.keys(this.pins).find((p) => this.pins[p] === id);
      return pin;
    },
    generatePins() {
      for (let i = 0; i < 24; i++) {
        this.pins[
          `https://cdn-serviceshift.s3.amazonaws.com/production/pins/marker2-${
            i + 1
          }.svg`
        ] = "";
      }
    },
    url_params() {
      const params = {};
      const url = window.location.search;
      const regex = /[?&;](.+?)=([^&;]+)/g;
      let match;
      if (url) {
        while ((match = regex.exec(url))) {
          params[match[1]] = decodeURIComponent(match[2]);
        }
      }
      return params;
    },
    addAppointments(appointments) {
      appointments.map((item) => {
        this.addAppointment(item);
      });
    },
    addAppointment(appointment) {
      const point = new window.google.maps.LatLng(
        appointment.latitude,
        appointment.longitude
      );
      const marker_map = new window.google.maps.Marker({
        position: point,
        map: this.map,
        icon: {
          url: this.getAppointmentMarker(appointment),
          scaledSize: new window.google.maps.Size(50, 50)
        },
        animation: window.google.maps.Animation.DROP,
        title: `${(appointment.technician || {}).first_name} ${
          (appointment.technician || {}).last_name
        }`
      });
      const marker_data = { data: appointment, marker: marker_map };
      this.appointments.push(marker_data);
      this.addMarkerListener(marker_map, marker_data);
    },
    getAppointmentMarker(job) {
      if (job.technician) {
        // Use tech map to get color
        let pin = Object.keys(this.pins).find((key) => {
          return this.pins[key] === job.technician.id;
        });
        if (!pin) {
          // set first empty to tech id
          pin = Object.keys(this.pins).find((key) => !this.pins[key]);
        }
        this.pins[pin] = job.technician.id;
        if (!this.legend.some((l) => l.id === job.technician.id)) {
          this.legend.push({
            id: job.technician.id,
            src: pin,
            label: `${job.technician.first_name} ${job.technician.last_name}`
          });
        }
        return pin;
      }
      return "";
    },
    addTechnician(params) {
      if (!params.position) {
        return;
      }
      let route = undefined;
      const point = new window.google.maps.LatLng(
        params.position.latitude,
        params.position.longitude
      );
      const marker = new window.google.maps.Marker({
        position: point,
        map: this.map,
        icon: this.setTechnicianIcon(params.technicianData),
        animation: window.google.maps.Animation.DROP,
        title: `${params.technicianData.first_name} ${params.technicianData.last_name}`
      });

      if (params.appointment && params.appointment.address) {
        const appointment_point = new window.google.maps.LatLng(
          params.appointment.address.latitude,
          params.appointment.address.longitude
        );
        route = this.setAppointmentRoute(point, appointment_point);
      }
      this.technicians.push({
        id: params.technicianId,
        marker: marker,
        data: params.technicianData,
        route: route
      });
    },
    updateTechnician(params, technician) {
      const point = new window.google.maps.LatLng(
        params.position.latitude,
        params.position.longitude
      );
      technician.marker.setPosition(point);
    },
    setAppointmentRoute(origin, destination) {
      const directionsDisplay = new window.google.maps.DirectionsRenderer();
      const directionsService = new window.google.maps.DirectionsService();
      directionsDisplay.setMap(this.map);
      directionsDisplay.setOptions({
        suppressMarkers: true,
        preserveViewport: true,
        polylineOptions: {
          strokeColor: "#05ACD5",
          strokeWeight: 4,
          geodesic: true
        }
      });
      directionsService.route(
        {
          destination: destination,
          origin: origin,
          travelMode: "DRIVING",
          provideRouteAlternatives: false
        },
        (response, status) => {
          if (status === "OK") {
            directionsDisplay.setDirections(response);
          } else {
            return status;
          }
        }
      );

      return directionsDisplay;
    },
    setTechnicianIcon(technician) {
      if (technician && technician.avatar && technician.avatar.url) {
        return {
          url: technician.avatar.url,
          scaledSize: new window.google.maps.Size(44, 44)
        };
      } else {
        return {
          url: technicianDefaultMarker,
          scaledSize: new window.google.maps.Size(44, 44)
        };
      }
    },
    addTechniciansLastLocation() {
      const queryParams = this.url_params();
      // Gets the date from url or today
      const date = window.moment(queryParams.service_date).format("DD/MM/YYYY");
      const params = Object.assign({}, { date });
      axios
        .get("/technicians/available_technicians_location", { params: params })
        .then(
          (response) => {
            response.data.map((item) => {
              this.addTechnician(item);
            });
            this.allTechs = response.data;
          },
          (error) => {
            console.log(error);
            // error callback
          }
        );
    },
    hideTechniciansExcept(technicianId) {
      for (let i = 0; i < this.technicians.length; i++) {
        const technician = this.technicians[i];
        if (technician.id != technicianId) {
          technician.marker.setVisible(false);
          if (technician.route) {
            technician.route.setMap(null);
          }
        } else {
          technician.marker.setVisible(true);
          if (technician.route) {
            technician.route.setMap(this.map);
          }
        }
      }
    },
    showAllTechnicians() {
      for (let i = 0; i < this.technicians.length; i++) {
        const technician = this.technicians[i];
        technician.marker.setVisible(true);
        if (technician.route) {
          technician.route.setMap(this.map);
        }
      }
    },
    emptyAppointments() {
      for (let i = 0; i < this.appointments.length; i++) {
        this.appointments[i]["marker"].setMap(null);
      }
      this.appointments = [];
    },
    getAllAppointments() {
      const today = window.moment(new Date()).format("MM/DD/YYYY");
      const params = Object.assign(
        {},
        { records_only: true, not_cancelled: true, service_date: today },
        this.url_params()
      );
      axios.get("/appointments/map_list", { params: params }).then(
        (response) => {
          this.addAppointments(response.data);
        },
        (response) => {
          console.log(response);
          // error callback
        }
      );
    },
    addMarkerListener: function (marker_map, marker_data) {
      window.google.maps.event.addListener(marker_map, "click", function () {
        window.open(
          window.location.origin + "/jobs/" + marker_data["data"].job_id,
          "order"
        );
      });
    }
  }
};
</script>

<style></style>
